import { DocumentActionsEnum, DocumentDispatchType } from './actions';

const initialState = {
  isLoading: false,
  values: {},
};

function reducerDocument(state = initialState, action: DocumentDispatchType) {
  switch (action.type) {
    case DocumentActionsEnum.DOCUMENT_CREATE:
    case DocumentActionsEnum.DOCUMENT_UPDATE:
    case DocumentActionsEnum.DOCUMENT_UPDATE_COMMENT: {
      const newValues = action.payload.values ? action.payload.values : state.values;

      return {
        ...state,
        isLoading: action.payload.isLoading,
        values: newValues,
      };
    }
    case DocumentActionsEnum.DOCUMENT_DELETE: {
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    }
    case DocumentActionsEnum.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
export default reducerDocument;
